import { KEYS, NAMESPACE } from "./i18n/dataFieldTypes.i18n";

export const DATA_FIELD_TYPE = {
    Unknown: 0,
    String: 1,
    Integer: 2,
    Decimal: 3,
    Boolean: 4,
    Choice: 5,
    DateTime: 6,
    User: 7,
    Location: 8,
    Timestamp: 9
};

const DATA_FIELD_TYPE_KEYS = {
    [DATA_FIELD_TYPE.Unknown]: KEYS.Unknown,
    [DATA_FIELD_TYPE.String]: KEYS.String,
    [DATA_FIELD_TYPE.Integer]: KEYS.Integer,
    [DATA_FIELD_TYPE.Decimal]: KEYS.Decimal,
    [DATA_FIELD_TYPE.Boolean]: KEYS.Boolean,
    [DATA_FIELD_TYPE.Choice]: KEYS.Choice,
    [DATA_FIELD_TYPE.DateTime]: KEYS.DateTime,
    [DATA_FIELD_TYPE.User]: KEYS.User,
    [DATA_FIELD_TYPE.Location]: KEYS.Location,
    [DATA_FIELD_TYPE.Timestamp]: KEYS.Timestamp
};

export function getDataFieldTypeDescription($app, dataFieldTypeId) {
    const key = DATA_FIELD_TYPE_KEYS[dataFieldTypeId];
    if (!key) {
        throw `Unrecognized field type ID: ${dataFieldTypeId}`;
    }

    return $app.res({ key, namespace: NAMESPACE });
}

export const DATA_FIELD_ENCODING_TYPE = {
    SingleLine: 1,
    MultiLine: 2,
    Email: 3,
    Price: 4
};

export const DATA_FIELD_GROUP_TYPE = {
    Name: 1,
    Address: 2,
    PVSystem: 3,
    Contact: 4,
    IncentiveSelector: 5,
    ExternalData: 6,
    Sensitive: 7,
    Table: 8,
    EnergyStorageSystem: 9,
    ProjectTable: 10
};

const DATA_FIELD_GROUP_TYPE_KEYS = {
    [DATA_FIELD_GROUP_TYPE.Name]: KEYS.Name,
    [DATA_FIELD_GROUP_TYPE.Address]: KEYS.Address,
    [DATA_FIELD_GROUP_TYPE.PVSystem]: KEYS.PVSystem,
    [DATA_FIELD_GROUP_TYPE.Contact]: KEYS.Contact,
    [DATA_FIELD_GROUP_TYPE.IncentiveSelector]: KEYS.IncentiveSelector,
    [DATA_FIELD_GROUP_TYPE.ExternalData]: KEYS.CustomList,
    [DATA_FIELD_GROUP_TYPE.Sensitive]: KEYS.SensitiveData,
    [DATA_FIELD_GROUP_TYPE.Table]: KEYS.Table,
    [DATA_FIELD_GROUP_TYPE.EnergyStorageSystem]: KEYS.EnergyStorageSystem
};

export function getDataFieldGroupTypeDescription($app, dataFieldGroupTypeId) {
    const key = DATA_FIELD_GROUP_TYPE_KEYS[dataFieldGroupTypeId];
    if (!key) {
        throw `Unrecognized group type ID: ${dataFieldGroupTypeId}`;
    }
    return $app.res({ key, namespace: NAMESPACE });
}

export const BUILT_IN_FIELD_TYPE = {
    ProjectNumber: 1,
    CurrentStatus: 2,
    LastStatusChangeTimestamp: 3,
    AssigneeEmail: 4,
    StatusChangeTimestamp: 5,
    DaysInCurrentStatus: 6,
    QueuePosition: 8,
    QueueTimestamp: 9,
    StatusHistory: 10,
    ProjectLandingPageUrl: 11,
    AdminPageUrl: 12,
    StatusTotalTime: 13,
    LastChangeTimestamps: 14,
    LastChangeUsers: 15,
    ProjectOwnerEmail: 16,
    ProjectOwnerCompany: 17,
    ProjectOwnerFirstName: 18,
    ProjectOwnerLastName: 19,
    ProgramName: 20,
    AssigneeName: 21,
    AssigneePhone: 22,
    NearestDeadlineDueDate: 23,
    NearestDeadlineName: 24,
    SpecificStatusTimestamp: 25,
    TotalTimeBetweenStatuses: 26
};

export const SHARE_TYPE = {
    None: 0,
    ByGlobalData: 1,
    ByCustomerGroup: 2
};

export const SCHEMA_TYPE = {
    DataField: 1,
    DataFieldGroup: 2,
    Attachment: 3
};
